import { MaintenanceError } from "@/features/errors/maintenance-error";

export const Route = createFileRoute({
  component: MaintenanceError,
});
